import { INVALID_MOVE } from 'boardgame.io/core';
import { debug } from '../../utils/debug';
import type { Ctx } from 'boardgame.io';
import type { AoSGameState } from '../../types';

/**
 * Production 配置を全てリセットする Move
 *
 * スナップショットから goodsDisplay を復元し、配置カウントをリセット
 *
 * @param G - ゲーム状態
 * @param ctx - Boardgame.io コンテキスト
 * @returns void or INVALID_MOVE
 */
export function resetProductionPlacement(
  { G, ctx }: { G: AoSGameState; ctx: Ctx }
): void | typeof INVALID_MOVE {
  // 1. Production選択チェック
  const player = G.players[ctx.currentPlayer];
  if (player.selectedAction !== 'PRODUCTION') {
    console.error(`[resetProductionPlacement] Production not selected`);
    return INVALID_MOVE;
  }

  // 2. スナップショット存在チェック
  if (!G.productionSnapshot) {
    console.error(`[resetProductionPlacement] No snapshot available`);
    return INVALID_MOVE;
  }

  // 3. スナップショットから復元
  G.goodsDisplay = JSON.parse(JSON.stringify(G.productionSnapshot));
  debug.log(`[resetProductionPlacement] Restored goodsDisplay from snapshot`);

  // 4. 配置カウントをリセット
  G.productionPlacementCount = 0;
  debug.log(`[resetProductionPlacement] Placement count reset to 0`);
}
